/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OmniGenerateIFrameUrlRequest
 */
export interface OmniGenerateIFrameUrlRequest {
    /**
     * 
     */
    dashboard_id: string;
    /**
     * 
     */
    user_timezone?: string;
}

/**
 * Check if a given object implements the OmniGenerateIFrameUrlRequest interface.
 */
export function instanceOfOmniGenerateIFrameUrlRequest(value: object): value is OmniGenerateIFrameUrlRequest {
    if (!('dashboard_id' in value) || value['dashboard_id'] === undefined) return false;
    return true;
}

export function OmniGenerateIFrameUrlRequestFromJSON(json: any): OmniGenerateIFrameUrlRequest {
    return OmniGenerateIFrameUrlRequestFromJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateIFrameUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dashboard_id': json['dashboard_id'],
        'user_timezone': json['user_timezone'] == null ? undefined : json['user_timezone'],
    };
}

export function OmniGenerateIFrameUrlRequestToJSON(json: any): OmniGenerateIFrameUrlRequest {
    return OmniGenerateIFrameUrlRequestToJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlRequestToJSONTyped(value?: OmniGenerateIFrameUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dashboard_id': value['dashboard_id'],
        'user_timezone': value['user_timezone'],
    };
}

